//
// Google Tag Manager loader.
//
// Configure in landing-page/.env:
//   REACT_APP_GTM_ID=GTM-XXXXXXX
//
// When set, this injects the standard GTM script + the iframe fallback for
// no-JS clients. When unset, the loader is a no-op so dev/local previews
// don't ship analytics to a fake container.
//
// Idempotent — repeated calls are safe.
//

const GTM_ID = process.env.REACT_APP_GTM_ID || '';
let installed = false;

export function installGtm() {
  if (installed) return;
  if (!GTM_ID) return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  installed = true;

  // Make sure dataLayer exists before the GTM snippet runs.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  // Inject the GTM <script>.
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(GTM_ID)}`;
  document.head.appendChild(s);

  // Inject the <noscript> iframe fallback into <body> if it isn't there yet.
  if (!document.getElementById('gtm-noscript')) {
    const ns = document.createElement('noscript');
    ns.id = 'gtm-noscript';
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(GTM_ID)}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    ns.appendChild(iframe);
    document.body.appendChild(ns);
  }
}
